export default __webpack_public_path__ + "static/media/iust.55c298a0.svg";